import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ProcessInfo from '../components/process/ProcessInfo'
import NotesPanel from '../components/stage/NotesPanel'
import AttacmentsOverview from '../components/attachment/AttacmentsOverview'
import RecordsPanel from '../components/stage/RecordsPanel'
import StageHeader from '../components/stage/StageHeader'
import PageContainer from '../components/common/PageContainer'
import { useGetStage } from '../api/stage'
import { useGetProcess } from '../api/process'
import { Step } from 'intro.js-react'
import MenuIcon from '@mui/icons-material/Menu'
import { Box, Fab, Grid, Stack, SwipeableDrawer } from '@mui/material'
import DrawerHeader from '../components/common/DrawerHeader'

export default function StagePage() {
  const params = useParams<{ sid: string; pid: string }>()
  const { data: stage } = useGetStage(params.sid)
  const { data: process } = useGetProcess(params.pid)
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false)

  useEffect(() => {
    window.onpopstate = function (event) {
      event.preventDefault()

      if (drawerOpen) {
        setDrawerOpen(false)
        event.stopPropagation()
      }
    }
  })

  return (
    <PageContainer
      introSteps={steps}
      header={
        <ProcessInfo
          year={process?.year}
          number={process?.number}
          stageId={stage?.id}
          description={process?.description}
          organization={process?.organization}
        />
      }
    >
      {!!stage && (
        <>
          <Grid container sx={{ height: '100%' }}>
            <Grid
              item
              xs={0}
              md={4}
              lg={3}
              sx={{ display: { xs: 'none', md: 'initial' } }}
            >
              <Stack spacing={1} height="100%">
                <RecordsPanel stageId={stage.id} />
                <NotesPanel stageId={stage.id} />
              </Stack>
            </Grid>
            <Grid item flexGrow={1} id="attachments-panel">
              <Stack spacing={3} height="100%">
                <StageHeader
                  title={stage?.title}
                  description={stage?.description}
                  sequenceNumber={1 + (stage?.sequenceNumber ?? 0)}
                />
                <AttacmentsOverview
                  attachments={stage?.attachments}
                  className="flex-grow"
                />
              </Stack>
            </Grid>
          </Grid>
          <Box sx={{ display: { md: 'none' } }}>
            <Fab color="primary" onClick={() => setDrawerOpen(true)} sx={{ mb: 2 }}>
              <MenuIcon sx={{ color: 'icon.light' }} />
            </Fab>
            <SwipeableDrawer
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
              onOpen={() => setDrawerOpen(true)}
              anchor="bottom"
              sx={{
                '.MuiPaper-root': {
                  height: '550px',
                  borderTopRightRadius: 10,
                  borderTopLeftRadius: 10,
                },
              }}
            >
              <DrawerHeader />
              <Stack spacing={1} height="100%">
                <RecordsPanel stageId={stage.id} />
                <NotesPanel stageId={stage.id} />
              </Stack>
            </SwipeableDrawer>
          </Box>
        </>
      )}
    </PageContainer>
  )
}

const steps: Step[] = [
  {
    element: '#stage-header',
    intro: 'عنوان و توضیحات مرحله را می‌توانید از اینجا ببینید.',
  },
  {
    element: '#records-panel',
    intro: 'پنل وضعیت کلی فرایند',
  },
  {
    element: '#change-stage-status',
    intro:
      'اگر مرحله و مستندات آن تکمیل‌ شده، ثبت کنید یا اگر متوجه مشکلی شدید، از همینجا برگشت بزنید.',
  },
  {
    element: '#stage-history',
    intro: 'در اینجا تاریخچه وضعیت این مرحله را می‌بینید',
  },
  {
    element: '#notes-panel',
    intro: 'و برای مشاهده و افزودن یادداشت از این پنل استفاده کنید.',
  },
  {
    element: '.resize-button',
    intro: 'برای تغییر اندازه پنل‌ها از این دکمه استفاده کنید.',
  },
  {
    element: '#attachments-list',
    intro: 'لیست مسنتدات مربوط به مرحله و وضعیت هر یک در این قسمت آمده است',
  },
  {
    element: '.attachments-card',
    intro: 'وضعیت مستندات از رنگ حاشیه آن‌ها مشخص است. آبی: ارسال‌شده، خاکستری: خالی',
  },
]
